import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { SessionSponsorInfo, SessionInfo } from 'src/app/store/reselectors/performerSponsors.reselector';
import { sponsorDisplayTypes } from 'src/app/store/sponsors.era';
import { sponsorStatus, Sponsor } from 'globals/store/sponsors.data';
import { singleSessionSponsorsReselector } from 'src/app/store/reselectors/sponsors.reselector';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { EntitySelectorData, EntitySelectorDialogComponent } from 'src/app/components/entities/entity-selector.dialog.component';
import { ManageSponsorData, ManageSponsorComponent } from '../manage/manage-sponsor.component';
import { CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Wrapper } from 'src/app/components/wrapper.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { StatusWrapperComponent } from 'src/app/components/wrappers/status-wrapper.component';
import { CommonModule } from '@angular/common';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { SponsorCardComponent } from 'src/app/components/cards/sponsor-card.component';
import { SortByIdsPipe } from 'src/app/services/pipes/sortByIds.pipe';

@Component({
    selector: 'sponsors',
    templateUrl: './sponsors.html',
    styleUrls: ['../../components/performers/performers.component.scss', 'sponsors.scss', '../manage/entity-drag.scss'],
    standalone: true,
    imports: [AddManageWrapperComponent, SortByIdsPipe, SponsorCardComponent, IconComponent, CdkDropList, CommonModule, StatusWrapperComponent],
})
export class SponsorsComponent extends Wrapper<SponsorsComponent> implements OnInit, OnChanges {

  @Input() displayType
  @Input() sessionId: string
  @Input() emptyText = 'No sponsors'
  @Input() readOnly = false
  @Input() fromManageDialog = true
  @Input() sponsorIds: string[] = []
  @Input() programId: string
  @Input() staticSponsorIds

  @Input() staticSponsorData: { sponsors, sponsorIdsBySessionIds, sponsorStatusBySessionIds } = null // for snapshot view only <== not implemented for sponsors yet
  ids: string[]
  displayTypes = sponsorDisplayTypes
  sponsorStatus = sponsorStatus
  sponsorInfos: SessionSponsorInfo[] = []
  sessionInfo: SessionInfo = null
  statusOptions = Object.values(sponsorStatus)

  threeDotOptions = [{ name: 'Remove sponsor from session', id: 'delete' }, { name: 'Edit sponsor', id: 'edit' }]
  sponsors: { [sId: string]: Sponsor } = {}
  noSponsors = false

  constructor(public changeDetectorRef: ChangeDetectorRef) {
    super()
  }

  ngOnInit() {
    this.subCallback(this.store.select(singleSessionSponsorsReselector, this.sessionId), (sessionInfo: SessionInfo) => {
      if (!this.sessionId || !sessionInfo) return
      this.sessionInfo = sessionInfo
      this.sponsorInfos = sessionInfo.sponsorInfos
      this.checkForSponsors()
    })
    this.subCallback(this.store.select('sponsors', 'entities'), sponsors => {
      this.sponsors = sponsors
      this.checkForSponsors()
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.sponsorIds) return
    const ids = [... changes.sponsorIds.currentValue]
    
    if (JSON.stringify(this.ids) !== JSON.stringify(ids)) {
      // console.log({ ids: jsonCopyObject(ids) })
      this.ids = ids
    }
  }

  dropSponsorIds(event: CdkDragDrop<SessionSponsorInfo[]>) {
    const newIds = [...this.ids]
    moveItemInArray(newIds, event.previousIndex, event.currentIndex)
    const same = JSON.stringify(this.ids) === JSON.stringify(newIds)
    if (same) return
    this.ids = newIds
    const session = this.sessionInfo.fullSession
    session.sponsorIds = newIds
    this.programService.updateSession(this.sessionInfo.programId, session)
  }

  dotMenuSelection({ event, option }, sponsor: Sponsor) {
    switch (option) {
      case 'delete':
        this.deleteFromSessionWithConfirm(sponsor, event)
        break;
      case 'edit':
        this.editSponsor(sponsor)
        break;
      default:
        console.log(`Missing selection [${option}] from three dot menu`)
        break;
    }
  }

  checkForSponsors() { // Sponsor ids are not removed from sessions when sponsors are removed from the event;  so we need workarounds like this
    if (this.sponsors && this.sponsorInfos) {
      this.noSponsors = !this.sponsorInfos.filter(({ sponsorId: id }) => !!this.sponsors[id]).length
    }
  }

  trackByPInfo(index, sInfo: SessionSponsorInfo) {
    return sInfo.sponsorId
  }

  changeStatus(sponsorId: string, status: string) {
    this.sponsorService.changeSponsorStatus(this.sessionInfo.id, this.sessionInfo.programId, status, sponsorId)
  }

  async editSponsor(sponsor: Sponsor) {
    const data: ManageSponsorData = { sponsorId: sponsor.id, readOnly: false }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageSponsorComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  async deleteFromSessionWithConfirm(sponsor: Sponsor, event) {
    const rect = event.target.getBoundingClientRect();
    const data: ConfirmDeleteData = {
      title: 'Remove ' + sponsor.name + ' from this session',
      deleteButtonText: 'REMOVE',
      rect,
      bottomOffset: -45,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.deleteFromSession(sponsor.id)
  }

  deleteFromSession(sponsorId) {
    // Deletion confirmation is nested in the status-wrapper component
    this.sponsorService.deleteSponsorFromSession(this.sessionInfo, sponsorId)
  }

  addSponsorsToASession(event) {
    const { unusedSponsors } = this.sessionInfo
    const sponsors = unusedSponsors
    const data: EntitySelectorData = { entities: sponsors, searchPlaceholder: 'Search or add sponsor', entityName: 'Sponsor', rect: (<HTMLElement>event.target).getBoundingClientRect() }
    openDialogGetResult(this.dialog,EntitySelectorDialogComponent, { width: '300px', data, disableClose: true, backdropClass: 'clear' }).then((selected: string[]) => {
      if (!selected) return
      this.sponsorService.addSponsorsToProgram(this.sessionInfo, selected)
    })

  }

}

